module.exports = __webpack_public_path__ + "img/selfLic.1869129a.svg";